<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M680.6 414.2H545.2V279.7c0-18-14.7-32.7-33.2-32.7-18 0-33.2 14.7-33.2 32.7v134.5H343.4c-18 0-33.2 14.7-33.2 32.7s14.7 32.7 33.2 32.7h135.5v134.5c0 18 14.7 32.7 33.2 32.7 18 0 33.2-14.7 33.2-32.7V479.6h135.9c18 0 33.2-14.7 33.2-32.7-.6-18-15.3-32.7-33.8-32.7z" />
        <path d="M726.6 97.8H297.4c-102.8 0-186.6 82.9-186.6 184.7v337.7c0 101.8 83.4 184.7 186.1 184.7h78.6L467 911c1.9 1.9 3.8 3.8 5.7 5.2.5.5.5.9.9.9 6.2 5.7 14.2 9 22.7 9 9 0 17.5-3.8 23.7-9.9l108-111.8h98.5c102.8 0 186.6-82.9 186.6-184.7V282.5c.1-101.8-83.8-184.7-186.5-184.7zm120.7 522.4c0 65.8-54 119.4-120.3 119.4H614.8c-9 0-17.5 3.8-23.7 9.9l-93.8 97.1-99.5-108-57.3.9H297c-66.3 0-120.3-53.5-120.3-119.4V282.5c0-65.8 54-119.4 120.3-119.4h429.6c66.3 0 120.3 53.5 120.3 119.4v337.7h.4z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
